import React from "react";
import { t } from "ttag";

import { useAppDispatch } from "../../reducers";
import { Actions } from "../actions";
import { IPhone } from "../models.interfaces";
import { FormView } from "./abstract/FormView";

interface IProps {
    phone: Partial<IPhone>;
}

export const CustomerDetailsPhone = (props: IProps) => {
    const dispatch = useAppDispatch();
    const actions = new Actions(dispatch);

    return (
        <FormView
            url={props.phone.url}
            baseURL={"/api/csr/user-phones/"}
            actions={actions}
            fields={[
                {
                    name: "user",
                    type: "hidden",
                },
                {
                    label: t`Phone Number`,
                    name: "phone_number",
                    placeholder: t`+1 (555) 555-5555`,
                    isRequired: true,
                    type: "phone",
                },
            ]}
            initialValues={props.phone}
        />
    );
};
